import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";

import video from "../assets/videos/launchcontrol.mp4";
import imageurl1 from "../assets/images/launchcontrol.png";
import video2 from "../assets/videos/service2.mp4";
function LaunchControl() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        Met Launch Control wordt ervoor gezorgd dat uw voertuig vanuit stilstand
        gemakkelijker de maximale snelheid kan bereiken. Dit heeft te maken met
        uw koppeling en gaspedaal bij het optrekken van uw voertuig.
      </p>
      <br />
      <p className="text-white text-lg">
        Bij X-TREMETUNINGS bieden wij de service om met een aanpassing in de ECU
        het maximaal aantal toeren dat uw motorblok kan maken te verminderen
        naar een bepaalde waarde.
      </p>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="LAUNCH CONTROL" />
      <ImageText2
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default LaunchControl;
